import {
	Component,
	EventEmitter,
	Input,
	OnDestroy,
	OnInit,
	Output
} from '@angular/core';
import { Subject } from 'rxjs/Subject';
import { ClientsDataServiceProvider } from '@services/client/clients.data.service';
import { MessageService } from '@services/helpers/message-service/message.service';

@Component({
	selector: 'save-optin-consent-modal',
	template: require('./save-optin-consent-modal.html')
})
export class SaveOptinConsentModalComponent implements OnInit, OnDestroy {
	@Input() optinStatement: string;
	@Input() clientId: number;

	@Output() onSaveOptIn: EventEmitter<any> = new EventEmitter();

	optinStatementForSave: string;
	button_disable: boolean;
	unsubscribe: Subject<void> = new Subject<void>();

	constructor(
		public clientsDataService: ClientsDataServiceProvider,
		public messageService: MessageService
	) {}

	ngOnInit() {
		this.optinStatementForSave = this.optinStatement;
		this.resetStatementOnModalHide();
	}

	ngOnDestroy() {
		this.unsubscribe.next();
		this.unsubscribe.complete();
	}

	saveOptIn(): void {
		if (
			!this.optinStatementForSave ||
			this.optinStatementForSave.trim().length === 0
		) {
			return this.messageService.showToaster('e_0', 'consent');
		}

		this.button_disable = true;

		this.clientsDataService
			.saveOptIn(this.clientId, this.optinStatementForSave)
			.finally(() => (this.button_disable = false))
			.subscribe(
				() => this.successSaveOptIn(),
				error => this.messageService.showDefaultErrorMessage(error)
			);
	}

	successSaveOptIn(): void {
		this.messageService.showToaster('s_1', 'general');
		this.onSaveOptIn.emit();
		$('#saveOptinConsentModal').modal('hide');
	}

	private resetStatementOnModalHide(): void {
		const vm = this;
		$('#saveOptinConsentModal').on('hidden.bs.modal', () => {
			vm.optinStatementForSave = vm.optinStatement;
		});
	}
}



// WEBPACK FOOTER //
// ./node_modules/angular2-template-loader!./node_modules/string-replace-webpack-plugin/loader.js?id=kkml25e9zf!./shared/components/base/client/modals/save-optin-consent-modal/save-optin-consent-modal.ts